
import Vue from "vue";
import TabList from "@/components/TabList.vue";
export default Vue.extend({
  components: { TabList },
  data: () => ({
    tab: {
      selectedTab: 0,
      tabTitle: "实验室人员",
      tabs: [
        { id: 0, text: "教师", path: "/staff/professor" },
        { id: 1, text: "博士生", path: "/staff/doctor" },
        { id: 2, text: "硕士生", path: "/staff/postgraduate" },
        { id: 3, text: "本科生", path: "/staff/undergraduates" },
        { id: 4, text: "毕业学生", path: "/staff/graduated" },
        { id: 5, text: "访问学者", path: "/staff/visitor" },
      ],
    },
  }),
  created() {
    const nameMap: any = { professor: 0, doctor: 1, postgraduate: 2, undergraduates: 3, graduated: 4, visitor: 5 };
    this.tab.selectedTab = nameMap[this.$route.name as string] ?? 0;
  },
});
